export default function Page404() {
  return (
    <div className="d-flex justify-content-center align-items-center h-100 p-3">
      <h3>404 not found</h3>
    </div>
  );
}
